var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover-image",class:{ 'has-images': _vm.hasImages }},_vm._l((_vm.imageUrls),function(image,i){return _c('div',{staticClass:"cover-image__image fade-in",style:(_vm.styles(i))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }